import {EffectCarousel} from 'theme';
import {animateSequence as animateTest} from 'vendor';

const mobileMQ = window.matchMedia('(max-width: 767px)');

class SliderCarousel extends EffectCarousel {
    // Put previous slides on the left, next slides on the right (mobile only)
    positionSlidesForMobile(activeIndex = this.index) {
        if (!this.slides) return;
        this.slides.forEach((slide, i) => {
            if (i === activeIndex) {
                slide.style.transform = 'translateX(0)';
                slide.style.opacity = 1;
            } else if (i < activeIndex) {
                slide.style.transform = 'translateX(-100%)'; // previous -> left
                slide.style.opacity = 0;
            } else {
                slide.style.transform = 'translateX(100%)'; // secondary/next -> right
                slide.style.opacity = 0;
            }
        });
    }

    createOnChangeAnimationControls(fromSlide, toSlide, {direction} = {}) {
        const isNext = direction === 'next';
        const isMobile = mobileMQ.matches;

        // Keep true directions
        const fromTransform = isNext
            ? ['translateX(0)', 'translateX(-100%)'] // moving left
            : ['translateX(0)', 'translateX(100%)']; // moving right

        const toTransform = isNext
            ? ['translateX(100%)', 'translateX(0)'] // enter from right
            : ['translateX(-100%)', 'translateX(0)']; // enter from left

        if (isMobile) {
            // Make sure slides are staged so the secondary is on the right
            this.positionSlidesForMobile(this.index);
            // Ensure the incoming slide starts at the correct edge
            toSlide.style.transform = toTransform[0];
            toSlide.style.opacity = 0;
        }

        const controls = animateTest([
            [fromSlide, {opacity: [1, 0], transform: fromTransform}, {duration: 0.3}],
            [toSlide, {opacity: [0, 1], transform: toTransform}, {duration: 0.3, at: '<'}],
        ]);

        // Re-stage after the animation so the peek stays on the right
        if (isMobile && controls?.finished) {
            controls.finished.then(() => this.positionSlidesForMobile(this.index));
        }

        return controls;
    }
}

if (!customElements.get('slider-carousel')) {
    window.customElements.define('slider-carousel', SliderCarousel);
}